const DB_NAME = 'webpos-db';
const DB_VERSION = 1;
let DB;

export default {

	async getDb() {
		return new Promise((resolve, reject) => {

			if(DB) { return resolve(DB); }
			// console.log('OPENING DB', DB_NAME);
			let request = window.indexedDB.open(DB_NAME, DB_VERSION);
			
			request.onerror = () => {
				// console.log('Error opening db', e);
				reject('Error');
			};
	
			request.onsuccess = e => {
                DB = e.target.result;
				resolve(DB);
			};
			
			request.onupgradeneeded = e => {
				// console.log('onupgradeneeded');
				let db = e.target.result;
				db.createObjectStore("user", { keyPath:'token' });
			};
		});
	},
	async deleteUser(user) {

		let db = await this.getDb();

		return new Promise(resolve => {

			let trans = db.transaction(['user'],'readwrite');
			trans.oncomplete = () => {
				resolve();
			};

			let store = trans.objectStore('user');
			store.delete(user.token);
		});	
	},
	async getUser() {

		let db = await this.getDb();

		return new Promise(resolve => {

			let trans = db.transaction(['user'],'readonly');
			trans.oncomplete = () => {
				resolve(user);
			};
			
			let store = trans.objectStore('user');
			let user = [];
			
			store.openCursor().onsuccess = e => {
				let cursor = e.target.result;
				if (cursor) {
					user.push(cursor.value)
					cursor.continue();
				}
			};

		});
	},
	async saveUser(user) {

		let db = await this.getDb();

		return new Promise(resolve => {

			let trans = db.transaction(['user'],'readwrite');
			trans.oncomplete = () => {
                resolve();
			};

			let store = trans.objectStore('user');
			store.put(user);

		});
	
	}

}